import { EmailValidator } from 'commons-validator-js';
export var cleanListOnlyActions = function (actions) {
    return actions.filter(function (action) { return !action.onlyInList; });
};
var emailValidator = new EmailValidator();
export var isEmailValid = function (email) {
    return emailValidator.isValid(email);
};
export var scrollToElement = function (el) {
    if (!el) {
        return;
    }
    try {
        // browser compatibility issue:
        // all browsers support boolean as arg for scrollIntoView(arg),
        // but not all (safari :confused:) support an object with options.
        // options give us better user experience, so we try to use them if we can.
        // see https://stackoverflow.com/questions/46919627/is-it-possible-to-test-for-scrollintoview-browser-compatibility/52393930#comment103745961_51070207
        var isBehaviorSupported = 'scrollBehavior' in document.documentElement.style;
        var options = {
            behavior: 'smooth',
            block: 'nearest',
        };
        el.scrollIntoView &&
            el.scrollIntoView(isBehaviorSupported ? options : true);
    }
    catch (error) {
        el.scrollIntoView && el.scrollIntoView(true);
    }
};
export var getDisplayName = function (contact) {
    if (!contact) {
        return '';
    }
    if (contact.name && (contact.name.first || contact.name.last)) {
        return [contact.name.first, contact.name.last].join(' ').trim();
    }
    if (contact.emails && contact.emails.length && contact.emails[0].email) {
        return contact.emails[0].email;
    }
    if (contact.phones && contact.phones.length && contact.phones[0].phone) {
        return contact.phones[0].phone;
    }
    return '';
};
//# sourceMappingURL=misc.utils.js.map